import React, { useState } from 'react'
import { Cell } from 'rsuite-table'
import Avatar from '../../../../assets/images/user.svg'
import './ProfileIcon.scss'

type Props = {
  rowData?: any,
  imgKey?: string,
  onImageClick?: (rowData: any) => void
}

const ProfileIconCell: React.FC<Props> = ({
  rowData = {},
  imgKey = 'photoUrl',
  onImageClick = () => {},
  ...props
}) => {
  const profileImgUrl = rowData[imgKey] ?? Avatar
  const [imgSrc, setImgSrc] = useState(profileImgUrl)

  const handleImageError = () => {
    setImgSrc(Avatar)
  }

  return (
    <Cell {...props} className="profile-icon-cell">
      <div className="profile-icon-wrapper">
        <img
          src={imgSrc}
          alt="profile"
          className="profile-image"
          onError={handleImageError}
        />
      </div>
    </Cell>
  )
}

export default ProfileIconCell
